import React, {useEffect, useState} from "react";
import {Box, Button, Grid, Modal, Typography, useMediaQuery} from "@mui/material";
import {useDispatch} from "react-redux";
import {useTypedSelector} from "../../../hooks/useTypeSelector";
import {PopupHeader} from "../../com/popupHeader/popupHeader";
import {TextInputWithLabel} from "../../../com/textInputWithLabel/textInputWithLabel";
import {
    createFlyerWithoutPageImages
} from "../../../store/actionCreators/flyerWithoutPageImagesActionCreator";
import {FlyerWithoutPageImagesDto} from "../../../dtos";
import {ActionType} from "../../../store/actionTypes";
import {getFlippingFlyer} from "../../../store";


const initialState = {
    numberOfPages: "2",
    pageWidth: "1000",
    pageHeight: "1500"
}

interface Props {
    isOpen: boolean;
    setIsOpen: (value: boolean) => void;
}

export const CreateFlyerWithEmptyPages: React.FC<Props> = ({
                                                               isOpen,
                                                               setIsOpen,
                                                           }) => {
    const dispatch = useDispatch();
    const isXs = useMediaQuery(`(max-width:699px)`);
    const flyersState = useTypedSelector((state) => state.flyers);
    const flyerDataWithoutImages = useTypedSelector((state) => state.flyerDataWithoutImages);
    const [state, setState] = useState<FlyerWithoutPageImagesDto>(initialState);


    useEffect(() => {
        if(flyerDataWithoutImages.type === ActionType.CREATE_FLYER_WITHOUT_PAGE_IMAGES_SUCCESS){
            dispatch(getFlippingFlyer(flyerDataWithoutImages.flyerId || -1));
            onClose();
        }
    }, [flyerDataWithoutImages.type])
    const onClose = () => {
        setIsOpen(false);
    }

    const onChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        const targetName = e.target.name;
        let value = e.target.value;
        const re = /^[0-9]+$/;
        if ((re.test(value) || value === "") && value !== "0") {
            if (targetName === "numberOfPages" && Number(value) > 1000) {
                value = "1000"
            }
            setState({
                ...state,
                [targetName]: value,
            });
        }
    }

    const compareDefaultStateAndCurrentState = (): boolean => {
        const stringDefaultState = JSON.stringify(state);
        const stringCurrentState = JSON.stringify(initialState);
        return stringDefaultState === stringCurrentState;
    }

    const createFlyer = () => {
        dispatch(createFlyerWithoutPageImages(state, flyersState))
    }

    return (
        <Modal open={isOpen} disableScrollLock={true}>
            <Box
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: isXs ? `90vw` : `25vw`,
                    minWidth: isXs ? "auto" : `420px`,
                    maxWidth: `90vw`,
                    backgroundColor: `#ffffff`,
                    display: "flex",
                    flexFlow: "column",
                    maxHeight: `90vh`,
                }}
            >
                <PopupHeader onClose={onClose} headerCaption={"Blank Flyer Setting"}/>
                <Box
                    pt={"24px"}
                    px={"24px"}
                >
                    <Box mb={`20px`}>
                        <Box mb={`5px`}>
                            <Typography fontWeight={700}>
                                Number of Pages:
                            </Typography>
                        </Box>
                        <Grid container alignItems={`flex-start`}>
                            <TextInputWithLabel
                                isRequired={true}
                                isNotValid={state.numberOfPages === ''}
                                labelGridSizeNumber={12}
                                fontSize={`16px`}
                                valueForInput={state.numberOfPages}
                                onChangeInput={onChange}
                                isBold={true}
                                fieldName={`numberOfPages`}
                            />
                        </Grid>
                    </Box>
                    <Box sx={{
                        display: "flex",
                        flexFlow: "row",
                        columnGap: "24px"
                    }}>
                        <Box>
                            <Box mb={`5px`}>
                                <Typography fontWeight={700}>
                                    Page Width (px):
                                </Typography>
                            </Box>
                            <Grid container alignItems={`flex-start`}>
                                <TextInputWithLabel
                                    isRequired={true}
                                    isNotValid={state.pageWidth === ''}
                                    labelGridSizeNumber={12}
                                    fontSize={`16px`}
                                    valueForInput={state.pageWidth}
                                    onChangeInput={onChange}
                                    isBold={true}
                                    fieldName={`pageWidth`}
                                />
                            </Grid>
                        </Box>
                        <Box>
                            <Box mb={`5px`}>
                                <Typography fontWeight={700}>
                                    Page Height (px):
                                </Typography>
                            </Box>
                            <Grid container alignItems={`flex-start`}>
                                <TextInputWithLabel
                                    isRequired={true}
                                    isNotValid={state.pageHeight === ''}
                                    labelGridSizeNumber={12}
                                    fontSize={`16px`}
                                    valueForInput={state.pageHeight}
                                    onChangeInput={onChange}
                                    isBold={true}
                                    fieldName={`pageHeight`}
                                />
                            </Grid>
                        </Box>
                    </Box>
                </Box>
                <Box
                    p={"24px"}
                >
                    <Button
                        disabled={state.pageHeight === "" || state.pageWidth === "" || state.numberOfPages === ""}
                        onClick={createFlyer}
                        sx={{
                            width: `100%`,
                            color: `initial`,
                            background: `#014780`,
                            // background: `linear-gradient(135.47deg, #DD5A01 3.9%, #F0CA21 100%)`,
                            height: `40px`,
                            borderRadius: `0`,
                            margin: "0",
                            '&:hover': {
                                background: `#014780`,
                                opacity: `0.7`
                            },
                            '&:disabled': {
                                opacity: `0.5`
                            }
                        }}
                    >
                        <Typography color={"#ffffff"}>
                            Save
                        </Typography>
                    </Button>
                </Box>
            </Box>

        </Modal>
    )
}